import { withFeatureBranch } from '../../../redux/flags';
import ExpandableComments from './ExpandableComments';
import CommentsContainer from './Comments.container';
import Comments from './Comments';
export default withFeatureBranch({
    deviation_page_recommended: ExpandableComments,
})(CommentsContainer(Comments));
//# sourceMappingURL=index.js.map